export const LoginFooter = () => {
	return (
		<div id="footer">
			<div className="wrap pt20 por">
				<div className="ornament"></div>
				<div className="center">COPYRIGHT &copy; 2013 Reţeaua privată de sănătate REGINA MARIA | <a href="https://www.reginamaria.ro/termeni-si-conditii" title="termeni si conditii">Termeni şi condiţii</a> | <a href="http://fundatiareginamaria.ro/"><span>Fundaţia REGINA MARIA</span></a></div>
			</div>
		</div>
	);
}




